import { Component, OnInit, AfterViewInit, ViewChild, ElementRef } from '@angular/core';
import { Router } from '@angular/router';
import { MatSort } from '@angular/material/sort';
import { MatPaginator } from '@angular/material/paginator';
import { MatTableDataSource } from '@angular/material/table';
import { Catalogo } from '../../../../../interfaces/interface-bakend/shared/catalogo/catalogo.interface';
import { CatalogoService } from '../../../../../services/shared/catalogo.service';
import { GuiMsjService } from 'src/app/services/shared/gui-msj.service';
import { SignoLocalidad } from 'src/app/interfaces/interface-bakend/entidades/signo-localidad.interface';
import { SignoLocalidadService } from 'src/app/services/entidades/signo-localidades.service';
import { PerfilesService } from 'src/app/services/perfiles/perfiles.service';
import { AuthService } from '@services/auth/auth.service';
import { Provincia } from '@interfaces/interface-bakend/provincias/provincias.interface';
import Swal from 'sweetalert2';
import { ProvinciaService } from '@services/provincias/provincias.service';
import { EntidadesKeys } from '@enum/entidades-keys.enum';

@Component({
  selector: 'app-localidades-listado',
  templateUrl: './localidades-listado.component.html',
  styleUrls: ['./localidades-listado.component.scss']
})
export class LocalidadesListadoComponent implements OnInit, AfterViewInit {
  @ViewChild('previousRoute') previousRouteLink: ElementRef;

  /* Data Table*/
  @ViewChild(MatSort) sort: MatSort;
  @ViewChild(MatPaginator) paginator: MatPaginator;
  displayedColumns: string[] = ['localidad', 'provincia', 'zona', 'activo', 'id'];
  dataSource: MatTableDataSource<any> = new MatTableDataSource([]); // Inicializar con array vacío
  zonas: Catalogo[] = [];
  zonaMap: Map<string, string> = new Map(); // Mapa para búsqueda rápida de zonas
  provincias: Provincia[] = [];
  provinciaMap: Map<string, string> = new Map();
  provinciaByIdMap: Map<string, string> = new Map();
  localidades: SignoLocalidad[];
  /* Fin Data Table*/

  flagLoaded: boolean = false;
  keyPerfil: string = '';

  constructor(
    private signoLocalidadesService: SignoLocalidadService,
    private catalogoService: CatalogoService,
    private provinciaService: ProvinciaService,
    private guiMsjService: GuiMsjService,
    private router: Router,
    private authService: AuthService,
    private perfilesService: PerfilesService,
  ) { }

  ngOnInit(): void {
    this.getPerfil().then(() => {
      this.perfilesService.allowedByUserLogon(this.router.url, this.previousRoute, this.keyPerfil);
    });
  }

  async ngAfterViewInit() {
    await this.loadDataPage();
    // Solo asignar si dataSource existe
    if (this.dataSource) {
      this.dataSource.sort = this.sort;
      this.dataSource.paginator = this.paginator;
    }
  }

  get previousRoute() {
    const previousRoute = this.previousRouteLink.nativeElement.getAttribute('href');
    return previousRoute;
  }

  async getPerfil() {
    try {
      const user = await this.authService.getUserLogon();
      if (user) {
        const { key } = user?.perfil;
        this.keyPerfil = key;
      }
    } catch (error) {
      console.log('ABM - Error al obtener el perfil del usuario', error);
      return '';
    }
  }

  async verLocalidad(id: string) {
    await this.guiMsjService.msjFormSubmit('Espere');
    Swal.showLoading();
    const localidad: SignoLocalidad = await this.signoLocalidadesService.getLocalidadById(id);
    if (localidad !== undefined) {
      this.router.navigateByUrl('/localidad-modificacion');
      this.signoLocalidadesService.setLocalidadSeleccionada(localidad);
    } else {
      Swal.close();
    }
  }

  async loadDataTableDetalle() {
    try {
      // Cargar todas las provincias y zonas de una vez
      await Promise.all([
        this.cargarProvincias(),
        this.cargarZonas()
      ]);

      const localidades: SignoLocalidad[] = await this.signoLocalidadesService.getLocalidades();
      const localidadesConDatos = localidades.map((localidad) => {
        if (!localidad) {
          return null;
        }

        // Obtener nombre de la provincia
        let provinciaConcepto = 'Sin provincia asignada';
        let provinciaId = null;
        const provinciaValue = localidad.provincia as any;

        if (provinciaValue && typeof provinciaValue === 'object') {
          if (provinciaValue.nombre) {
            provinciaConcepto = provinciaValue.nombre;
          } else if (provinciaValue._id) {
            provinciaId = String(provinciaValue._id);
            provinciaConcepto = this.provinciaMap.get(provinciaId) || 'Provincia no encontrada';
          } else if (provinciaValue.id != null) {
            provinciaId = provinciaValue.id;
            provinciaConcepto = this.provinciaByIdMap.get(String(provinciaValue.id)) || 'Provincia no encontrada';
          }
        } else if (typeof provinciaValue === 'string' && provinciaValue.trim() !== '') {
          provinciaId = provinciaValue;
          provinciaConcepto = this.provinciaMap.get(provinciaValue) || 'Provincia no encontrada';
        }

        // Obtener nombre de la zona (usando el mapa local - SIN llamadas HTTP individuales)
        let zonaConcepto = 'Sin zona asignada';
        let zonaId = null;
        const zonaValue = localidad.zona as any;

        if (typeof zonaValue === 'string' && zonaValue.trim() !== '') {
          zonaId = zonaValue;
          zonaConcepto = this.zonaMap.get(zonaId) || 'Zona no encontrada';
        } 
        else if (zonaValue === null) {
          zonaConcepto = 'Sin zona asignada';
        }
        else if (zonaValue && typeof zonaValue === 'object' && zonaValue._id) {
          zonaId = zonaValue._id;
          zonaConcepto = this.zonaMap.get(zonaId) || 'Zona no encontrada';
        }
        else {
          zonaConcepto = 'Sin zona asignada';
        }

        return {
          id: localidad._id,
          concepto: localidad.nombre,
          activo: localidad.activo !== undefined ? localidad.activo : false,
          zona: zonaConcepto,
          zonaId: zonaId,
          provincia: provinciaConcepto,
          provinciaId: provinciaId,
        };
      });

      // Filtrar elementos null y undefined
      const filteredLocalidades = localidadesConDatos.filter((item) => item != null);

      this.dataSource = new MatTableDataSource(filteredLocalidades);

      // Configurar el filtro personalizado
      this.dataSource.filterPredicate = (data: any, filter: string): boolean => {
        const concepto = data.concepto ? data.concepto.toLowerCase() : '';
        const activo = data.activo ? 'si' : 'no';
        const zona = data.zona ? data.zona.toLowerCase() : '';
        const provincia = data.provincia ? data.provincia.toLowerCase() : '';
        
        return concepto.includes(filter) || activo.includes(filter) || zona.includes(filter) || provincia.includes(filter);
      };

      // Asignar sort y paginator si están disponibles
      if (this.sort) {
        this.dataSource.sort = this.sort;
      }
      if (this.paginator) {
        this.dataSource.paginator = this.paginator;
      }
    } catch (error) {
      console.error('Error cargando datos:', error);
      // Asegurar que dataSource esté inicializado incluso en error
      this.dataSource = new MatTableDataSource([]);
    }
  }

  async cargarProvincias() {
    try {
      this.provincias = await this.provinciaService.findAll();
      // Crear mapas para búsqueda rápida: _id -> nombre y id numérico -> nombre
      this.provincias.forEach(provincia => {
        if (provincia._id && provincia.nombre) {
          this.provinciaMap.set(provincia._id, provincia.nombre);
        }
        const numId = (provincia as any).id ?? (provincia as any).numero;
        if (numId != null && provincia.nombre) {
          this.provinciaByIdMap.set(String(numId), provincia.nombre);
        }
      });
    } catch (error) {
      console.error('Error cargando provincias:', error);
    }
  }

  async cargarZonas() {
    try {
      // Asumiendo que EntidadesKeys.ZONAS está disponible.
      const zonas = await this.catalogoService.findDescendantsByKey(EntidadesKeys.ZONAS);
      if (zonas) {
        this.zonas = zonas;
        // Crear mapa para búsqueda rápida: id -> concepto
        this.zonas.forEach(zona => {
          if (zona._id && zona.concepto) {
            this.zonaMap.set(zona._id, zona.concepto);
          }
        });
      }
    } catch (error) {
      console.error('Error al cargar las zonas', error);
    }
  }

  applyFilter(event: Event) {
    const filterValue = (event?.target as HTMLInputElement)?.value.trim().toLowerCase();

    if (this.dataSource) {
      this.dataSource.filter = filterValue;

      if (this.dataSource.paginator) {
        this.dataSource.paginator.firstPage();
      }
    }
  }

  async loadDataPage() {
    await this.loadDataTableDetalle();
    this.flagLoaded = true;
  }

  hasData(index: number, row: any): boolean {
    return row != null && row !== undefined;
  }
}